module.exports = __webpack_public_path__ + "pc-top-assets/img/yucho.fd723e86.png";